/* Infinite scroll for collection grids — appends next-page cards via Intersection Observer.
   Fires 'collection:newcards' so collection-filter.js can register and filter the fresh cards. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-product-grid]');
  var sentinel = document.querySelector('[data-scroll-sentinel]');
  var loader = document.querySelector('[data-scroll-loader]');
  if (!grid || !sentinel) return;

  function nextUrl() {
    var a = document.querySelector('[data-next-page]');
    return a ? a.getAttribute('href') : null;
  }

  var fetching = false;

  function loadMore() {
    var url = nextUrl();
    if (!url || fetching) return;
    fetching = true;
    if (loader) loader.hidden = false;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCards = Array.prototype.slice.call(
          doc.querySelectorAll('[data-product-grid] [data-product]')
        );
        var nextA = doc.querySelector('[data-next-page]');
        var newNext = nextA ? nextA.getAttribute('href') : null;

        // Update or clear the next-page link
        var curA = document.querySelector('[data-next-page]');
        if (curA) {
          if (newNext) curA.setAttribute('href', newNext);
          else curA.removeAttribute('href');
        }

        // Reflect the page we just consumed in the address bar
        history.replaceState({}, '', url);

        // Skip cards already on the page — collection-filter.js may have loaded
        // this page itself to sort/filter across the whole collection.
        newCards = newCards.filter(function (card) {
          var link = card.querySelector('a[href]');
          return !(link && grid.querySelector('[data-product] a[href="' + link.getAttribute('href') + '"]'));
        });

        // Append cards; trigger reveal transition on the next frame
        newCards.forEach(function (card) {
          grid.appendChild(card);
          requestAnimationFrame(function () { card.classList.add('is-in'); });
        });

        // Notify filter.js so it registers and filters the new cards
        document.dispatchEvent(new CustomEvent('collection:newcards', {
          detail: { cards: newCards }
        }));

        fetching = false;
        if (loader) loader.hidden = true;
        if (!newNext) {
          observer.disconnect();
          sentinel.hidden = true;
        }
      })
      .catch(function () {
        fetching = false;
        if (loader) loader.hidden = true;
      });
  }

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) loadMore();
  }, { rootMargin: '400px' });

  if (nextUrl()) {
    observer.observe(sentinel);
  } else {
    sentinel.hidden = true;
  }
})();
